import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ProductsFilters, TYPES } from '../../../commons/models/product';

@Component({
    selector: "app-products-filters",
    templateUrl: "./products-filters.component.html",
    styleUrls: ["./products-filters.component.scss"]
})
export class ProductsFiltersComponent {
    @Output()
    onFilter: EventEmitter<ProductsFilters> = new EventEmitter();
    
    private _defaultFilters: ProductsFilters;
    filtersForm: FormGroup;
    TYPES = TYPES

    constructor(private fb: FormBuilder) {
    this._createForm();
    }

    private _createForm() {
    let group = {
        search: "",
        type: ""
    }

    this.filtersForm = this.fb.group(group);
    }

    applyFilters() {
    this.onFilter.emit(this._getPayment());
    }

    private _getPayment(): ProductsFilters {
    let filters: ProductsFilters = {}
    if (this.filtersForm) {
        const values = this.filtersForm.value;
        filters.search = values.search;
        filters.type = values.type
    }
    return filters;
    }

    resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
        search: "",
        type: ""
    });
    this._setDefaultValues();
    this.applyFilters();
    }

    get defaultFilters(): ProductsFilters {
    return this._defaultFilters;
    }

    @Input()
    set defaultFilters(defaultFilters: ProductsFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
    }

    private _setDefaultValues() {
    if (this.defaultFilters) {
        if (this.filtersForm) {
        this.filtersForm.patchValue({
            search: this.defaultFilters.search,
            type: this.defaultFilters.type
        })
        }
    }
    }
}